// D107: what a unit-cost cell shows on a line that has no real vendor. Not an input - a button
// that opens the Master Catalogue "Add item" popup (vendor required), because no price may
// exist without a registered vendor. Shows the line's present cost when it has one (so a
// legacy line is not blanked), otherwise says what clicking does.
import React from 'react';
import { LINE_COST_NEEDS_VENDOR_MESSAGE } from './lineVendor';

interface CostNeedsVendorCellProps {
  /** The cost as the cell would print it (prefix, figure, suffix), or null when the line has none. */
  shown: string | null;
  onOpen: () => void;
}

export const CostNeedsVendorCell: React.FC<CostNeedsVendorCellProps> = ({ shown, onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    title={`${LINE_COST_NEEDS_VENDOR_MESSAGE} Click to add it now.`}
    className="w-full min-w-0 px-1 py-0.5 rounded text-center text-xs leading-tight text-primary-600 hover:bg-blue-50 hover:text-primary-700 font-semibold"
  >
    {shown ?? 'Add to catalogue to price'}
  </button>
);

export default CostNeedsVendorCell;
